import React from 'react';
import './../scss/LoadMoreButton.scss';
import PropTypes from 'prop-types';

const { __ } = window.wp.i18n;

class LoadMoreButton extends React.Component {
  handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      if (e.key === ' ') e.preventDefault();
      this.props.loadMore();
    }
  };

  render () {
    return (
      <a
        className="filters-more"
        aria-label="Load More about jobs"
        role="button"
        tabIndex="0"
        onKeyDown={this.handleKeyDown}
        onClick={this.props.loadMore}
        href="#"
      >
        {__('Load More', 'macs-react-jobs')}
</a>
    );
  }
}

LoadMoreButton.propTypes = {
  loadMore: PropTypes.func.isRequired
};
export default LoadMoreButton;
